import React from 'react'
import { DispatchProp,connect } from 'react-redux'
import { State } from '../store'
import Notification from './Notification'

type _props =
{
  notifications:State['notifications']['notifications']
}
type Props = _props & DispatchProp<any>
class Notifications extends React.Component<Props>
{
  render()
  {
    return (
      <div className="growler-wrapper">
        { this.props.notifications.map((v) => <Notification key={ v.id } notification={ v } />) }
      </div>
    )
  }
}

export default connect((state:State) => ({
  notifications:state.notifications.notifications
}))(Notifications)
